<div mat-dialog-content>
  <p>
    {{ 'acceptConditionsDescription' | translate:{ company: company.trade_name } }}
  </p>
</div>

<div mat-dialog-actions>
  <button type="submit" class="btn btn-primary btn-w-100" (click)="accept()">
    <ng-container *ngIf="loading">
      <mat-progress-spinner color="white" mode="indeterminate" diameter="20"></mat-progress-spinner>
    </ng-container>
    <ng-container *ngIf="!loading">
      <mat-icon style="margin-right: 5px;">task_alt</mat-icon>
      {{ 'acceptConditions' | translate }}
    </ng-container>
  </button>
</div>
